export default {
    props: {
        contentUrl: {
            type: String,
            kComposite: 'content.url'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoTooltip/Content.js